export default {
	data() {
		return {
			sortOptions: {
				LONGESTPISTE: 'longestPisteLength',
				RATING: 'reviews.average'
			},
			showMapIcons: true
		};
	},
	methods: {
		sortBy: function(field) {
			if (field === this.options.sortBy) {
				this.options.sortDesc = !this.options.sortDesc;
			} else {
				this.options.sortDesc = [
					this.sortOptions.RATING,
					this.sortOptions.LONGESTPISTE
				].includes(field);
				this.options.sortBy = field;
			}
		},
		getSortingClass: function(field) {
			return [
				'never-visited',
				this.options.sortDesc ? 'desc' : 'asc',
				this.options.sortBy === field ? 'active' : ''
			];
		}
	},
	computed: {
		localdestinations_with_location: function() {
			return this.mapped_localdestinations.filter(
				destination => destination.geography && destination.geography.location
			);
		},
		localdestinations_without_location: function() {
			return this.mapped_localdestinations.filter(
				destination =>
					!(destination.geography && destination.geography.location)
			);
		},
		mapped_localdestinations: function() {
			return this.localdestinations.map(destination => {
				const type = destination.__typename.toLowerCase();
				if (type === 'organisation') {
					destination.to = this.localePath({
						name: 'localdestinations-organisation',
						params: { organisation: destination.slug }
					});
				} else {
					destination.to = this.localePath({
						name: `localdestinations-${type}s-slug`,
						params: { slug: destination.slug }
					});
				}
				return destination;
			});
		}
	}
};
